import {
    SAVE_MEDICAL_NOTES_REQUEST,
    SAVE_MEDICAL_NOTES_SUCCESS,
    SAVE_MEDICAL_NOTES_ERROR
  } from "./SaveMedicalNotesTypes";
  
  const initialState = {
    loading: false,
    successMessage: "",
    errorMessage: "",
    isSubmitted: false,
    savedMedicalNotes: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case SAVE_MEDICAL_NOTES_REQUEST:
        return {
          ...state,
          isSubmitted: true,
          loading: true
        };
      case SAVE_MEDICAL_NOTES_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          savedMedicalNotes: action.payload,
          successMessage: "Notes created and saved to patient file successfully!",
          errorMessage: ""
        };
      case SAVE_MEDICAL_NOTES_ERROR:
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          savedMedicalNotes: [],
          errorMessage: action.payload
        };
      default:
        return state;
    }
  };
  